import React from "react";
import { Order, OrderItem } from "depoto-core";
import { ProductDescriptionColumn } from "./ProductDescriptionColumn";
import './OrderItemListRow.css'
import { FormInput } from "./form/FormInput.tsx";
import { updateBill, getDiscountedPricesForOrderItem, formatPrice, OrderItemType } from "../utils";
import { useCore } from "../hooks";
import { Btn } from "./Btn.tsx";
import { ModalCustomOrderItem } from "./ModalCustomOrderItem.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  orderItem: OrderItem
}
export const OrderItemListRow: React.FC<Props> = ({ orderItem }) => {
  const { currentOrder, setCurrentOrder, currency } = useCore()

  const updateQuantity = (quantity: any) => {
    if (orderItem.quantity === Number(quantity) || Number(quantity) === 0) {
      return
    }
    orderItem.quantity = Number(quantity)
    updateBill({ currentOrder, setCurrentOrder, orderItem })
  }

  if (orderItem?.product?.id > 0) {
    return (
      <div>
        <div className="w-full flex flex-col order-item-list-row bg-white p-2 h-row border-1 boder-solid border-border-light mb-1">
          <div className="flex flex-row items-center w-full">
            <ProductDescriptionColumn product={orderItem.product} areTagsShown={false} />
            <div className="font-bold flex flex-col items-start">
              {formatPrice(orderItem.priceAll, currency?.id)}
              {getDiscountedPricesForOrderItem(orderItem).priceAll !== orderItem.priceAll && (
                <div>[{formatPrice(getDiscountedPricesForOrderItem(orderItem).priceAll, currency?.id)}]</div>
              )}
              {orderItem?.sale !== 0 && (
                <div className="order-item-list-sale">Sleva: {orderItem.sale}%</div>
              )}
            </div>
            <div className="flex flex-row items-center order-item-list-row-amounts">
              <Btn icon="fa-minus" onClick={() => updateQuantity(orderItem.quantity - 1)} className="btn-primary w-1/2" />
              <FormInput type="number" className="!mb-0" value={`${orderItem.quantity}`} onChange={q => updateQuantity(q)} />
              <Btn icon="fa-plus" onClick={() => updateQuantity(orderItem.quantity + 1)} className="btn-primary" />
            </div>
            <ModalCustomOrderItem orderItem={orderItem} />
          </div>
          {orderItem?.note?.length > 0 && (
            <div className="order-item-list-note"><FontAwesomeIcon icon={'message-pen'} className="mr-1" /> {orderItem.note}</div>
          )}
        </div>

      </div>
    )
  }
  if (!orderItem?.product) {
    return (
      <div>
        <div className="w-full flex flex-col order-item-list-row bg-white p-2 h-row border-1 boder-solid border-border-light mb-1">
          <div className="flex flex-row items-center w-full">
            <div className="font-bold">{orderItem.name}</div>
            <div className="font-bold">
              {formatPrice(orderItem.priceAll, currency?.id)}
              {getDiscountedPricesForOrderItem(orderItem).priceAll !== orderItem.priceAll && (
                <div>[{formatPrice(getDiscountedPricesForOrderItem(orderItem).priceAll, currency?.id)}]</div>
              )}
              {orderItem?.sale !== 0 && (
                <div>Sleva: {orderItem.sale}%</div>
              )}
            </div>
            <div className="flex flex-row items-center order-item-list-row-amounts">
              {orderItem.type === OrderItemType.voucherToCreate ? (
                <FormInput className="!mb-0" value={`${orderItem.quantity}`} isDisabled={true} />
              ) : (
                <>
                  <Btn icon="fa-minus" onClick={() => updateQuantity(orderItem.quantity - 1)} className="btn-primary w-1/2" />
                  <FormInput className="!mb-0" value={`${orderItem.quantity}`} onChange={q => updateQuantity(q)} />
                  <Btn icon="fa-plus" onClick={() => updateQuantity(orderItem.quantity + 1)} className="btn-primary" />
                </>
              )}
            </div>
            <ModalCustomOrderItem orderItem={orderItem} />
          </div>
          {orderItem?.note?.length > 0 && (
            <div className="order-item-list-note"><FontAwesomeIcon icon={'message-pen'} className="mr-1" /> {orderItem.note}</div>
          )}
        </div>

      </div>
    )
  }

}
